import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const orderApi = createAsyncThunk(
  "order",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/order", { params });
    return response.data;
  }
);

const orderSlice = createSlice({
  name: "order",
  initialState: {
    order: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(orderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(orderApi.fulfilled, (state, action) => {
        state.order = action.payload;
        state.loading = false;
      })
      .addCase(orderApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default orderSlice.reducer;
